<div>
  <p>
    Dear Partners,<br>
    <br>
    As we grow as a team, we are changing the company behind Smartie Pants Platform with Smartie Pants Ltd. 
    That is why we are changing our <a href="{{publicWebsiteUrl}}/{{userRouteByRole}}/terms-of-service" target="_blank">Terms of Service</a>, <a href="{{publicWebsiteUrl}}/privacy-policy" target="_blank">Privacy Policy</a> and <a href="{{publicWebsiteUrl}}/cookie-policy" target="_blank">Cookie Policy</a>. The changes relate to the company name and the governing law only.
    These changes will go into effect within 5 working days as of this notification.

    Thank you for being a member of the Smartie Pants Platform.
  </p>
</div>
<button
  type="button"
  class="btn btn-outline-primary btn-block"
  (click)="onClose()"
>
  Continue
</button>
